export class UserSettings {
    constructor(aolPeriod?: string, sortAsc?: boolean) {
        this.aolPeriod = aolPeriod ?? null;
        this.sortAsc = sortAsc ?? null;
    }
    aolPeriod: string;
    sortAsc: boolean;
}
